export const data = {
   set: "DATA/SET",
} as const;

export const payment = { setCard: "SET/CARD", setPhone: "SET/PHONE", setWithoutPassbook: "SET/WITHOUTPASSBOOK" };

export const willAutoBackup = {
   setOn: "SETON/WILLAUTOBACKUP",
   setOff: "SETOFF/WILLAUTOBACKUP",
} as const;

export const dimensions = {
   sync: "WINDOW_DIMENSIONS_SYNC",
} as const;

export const order = {
   temp: {
      call: "TEMP/ORDER_CALL",
      send: "TEMP/ORDER_SEND",
      success: "TEMP/ORDER_SUCCESS",
      fail: "TEMP/ORDER_FAIL",
      reset: "TEMP/ORDER_RESET",
   },
} as const;

export const temp = {
   get: {
      call: "GET/TEMP_CALL",
      send: "GET/TEMP_SEND",
      success: "GET/TEMP_SUCCESS",
      fail: "GET/TEMP_FAIL",
      reset: "GET/TEMP_RESET",
   },
   set: {
      call: "SET/TEMP_CALL",
      send: "SET/TEMP_SEND",
      success: "SET/TEMP_SUCCESS",
      fail: "SET/TEMP_FAIL",
      reset: "SET/TEMP_RESET",
   },
   sync: {
      call: "SYNC/TEMP_CALL",
      send: "SYNC/TEMP_SEND",
      success: "SYNC/TEMP_SUCCESS",
      fail: "SYNC/TEMP_FAIL",
      reset: "SYNC/TEMP_RESET",
   },
   orderClone: {
      call: "ORDERCLONE/TEMP_CALL",
      send: "ORDERCLONE/TEMP_SEND",
      success: "ORDERCLONE/TEMP_SUCCESS",
      fail: "ORDERCLONE/TEMP_FAIL",
      reset: "ORDERCLONE/TEMP_RESET",
   },
} as const;

export const gallerys = {
   get: {
      call: "GET/GALLERY_CALL",
      send: "GET/GALLERY_SEND",
      success: "GET/GALLERY_SUCCESS",
      fail: "GET/GALLERY_FAIL",
      reset: "GET/GALLERY_RESET",
   },
   search: {
      call: "SEARCH/GALLERY_CALL",
      send: "SEARCH/GALLERY_SEND",
      success: "SEARCH/GALLERY_SUCCESS",
      fail: "SEARCH/GALLERY_FAIL",
      reset: "SEARCH/GALLERY_RESET",
   },
   insert: {
      call: "INSERT/GALLERY_CALL",
      send: "INSERT/GALLERY_SEND",
      success: "INSERT/GALLERY_SUCCESS",
      fail: "INSERT/GALLERY_FAIL",
      reset: "INSERT/GALLERY_RESET",
   },
   update: {
      call: "UPDATE/GALLERY_CALL",
      send: "UPDATE/GALLERY_SEND",
      success: "UPDATE/GALLERY_SUCCESS",
      fail: "UPDATE/GALLERY_FAIL",
      reset: "UPDATE/GALLERY_RESET",
   },
   delete: {
      call: "DELETE/GALLERY_CALL",
      send: "DELETE/GALLERY_SEND",
      success: "DELETE/GALLERY_SUCCESS",
      fail: "DELETE/GALLERY_FAIL",
      reset: "DELETE/GALLERY_RESET",
   },
} as const;

export const artists = {
   get: {
      call: "GET/ARTISTS_CALL",
      send: "GET/ARTISTS_SEND",
      success: "GET/ARTISTS_SUCCESS",
      fail: "GET/ARTISTS_FAIL",
      reset: "GET/ARTISTS_RESET",
   },
   search: {
      call: "SEARCH/ARTISTS_CALL",
      send: "SEARCH/ARTISTS_SEND",
      success: "SEARCH/ARTISTS_SUCCESS",
      fail: "SEARCH/ARTISTS_FAIL",
      reset: "SEARCH/ARTISTS_RESET",
   },
   insert: {
      call: "INSERT/ARTISTS_CALL",
      send: "INSERT/ARTISTS_SEND",
      success: "INSERT/ARTISTS_SUCCESS",
      fail: "INSERT/ARTISTS_FAIL",
      reset: "INSERT/ARTISTS_RESET",
   },
   update: {
      call: "UPDATE/ARTISTS_CALL",
      send: "UPDATE/ARTISTS_SEND",
      success: "UPDATE/ARTISTS_SUCCESS",
      fail: "UPDATE/ARTISTS_FAIL",
      reset: "UPDATE/ARTISTS_RESET",
   },
   delete: {
      call: "DELETE/ARTISTS_CALL",
      send: "DELETE/ARTISTS_SEND",
      success: "DELETE/ARTISTS_SUCCESS",
      fail: "DELETE/ARTISTS_FAIL",
      reset: "DELETE/ARTISTS_RESET",
   },
} as const;
